import { writable } from 'svelte/store';

export const energyTypeOptions = writable([]);
export const mechanismOptions = writable([]);
export const allControls = writable([]);
export const controlOptions = writable([]);
export const iconOptions = writable([]);
export const hazard = writable({
  name: '',
  energy_type: '',
  mechanism_id: '',
  icon_id: '',
  focus_questions: [],
  controls: [],
  ppe: false,
});

export const control = writable({
  name: '',
  description: '',
  icon_id: '',
});

export const hazardDetail = writable({});
export const relatedActivities = writable({});
export const relatedActivitiesList = writable({});
